import React, { useContext, useState, useEffect, useReducer, useRef, useMemo } from "react";
import { resolveHistoryCursor } from "./resolveHistoryCursor";
import { isSameDay, parseISO, format } from "date-fns";
import clsx from "clsx";
import { isNil } from "lodash";
import { blue, green } from "@material-ui/core/colors";
import {
  Button,
  Divider,
  Typography,
  IconButton,
  makeStyles
} from "@material-ui/core";

import {
  AccessTime,
  Done,
  DoneAll,
  ExpandMore,
  GetApp,
  Reply
} from "@material-ui/icons";
import LockIcon from '@material-ui/icons/Lock';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AssignmentIcon from '@material-ui/icons/Assignment';
import HistoryIcon from '@material-ui/icons/History';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import PauseIcon from "@material-ui/icons/Pause";
import VideocamIcon from "@material-ui/icons/Videocam";
import FullscreenIcon from "@material-ui/icons/Fullscreen";
import VolumeUpIcon from "@material-ui/icons/VolumeUp";
import VolumeOffIcon from "@material-ui/icons/VolumeOff";
import Slider from "@material-ui/core/Slider";
import MarkdownWrapper from "../MarkdownWrapper";
import VcardPreview from "../VcardPreview";
import { parseVcard } from "../../utils/parseVcard";
import LocationPreview from "../LocationPreview";
import ModalImageCors from "../ModalImageCors";
import MessageOptionsMenu from "../MessageOptionsMenu";
import PluginBridge, { usePluginBridge } from "../PluginBridge";
// Contexto dos slots da bolha — helper testável, inclui o `metadata` do plugin.
import { messageSlotContext } from "./messageSlotContext";
import { useHasSlot } from "../ChannelIcon";
import { tickets as ticketsUI } from "@markedesk/plugin-sdk/ui";
import whatsBackground from "../../assets/wa-background.png";
import whatsBackgroundDark from "../../assets/wa-background-dark.png";
import YouTubePreview from "../ModalYoutubeCors";
import PdfPreview from "../PdfPreview";
import MediaUnavailable from "../MediaUnavailable";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import { useDraftInsert } from "../../context/DraftInsert/DraftInsertContext";
import { ForwardMessageContext } from "../../context/ForwarMessage/ForwardMessageContext";
import AdMetaPreview from "../AdMetaPreview";
import api from "../../services/api";
import {
  belongsToThisThread as belongsToThread,
  mergeUpdatedMessage,
  buildTicketDataIndex,
  shouldRenderSeparator,
  resolveSeparatorQueue
} from "./mergedHistory";
import toastError from "../../errors/toastError";
import { toast } from "react-toastify";
import { i18n } from "../../translate/i18n";
import SelectMessageCheckbox from "./SelectMessageCheckbox";
import useCompanySettings from "../../hooks/useSettings/companySettings";
import { AuthContext } from "../../context/Auth/AuthContext";
import { QueueSelectedContext } from "../../context/QueuesSelected/QueuesSelectedContext";
import AudioModal from "../AudioModal";
import { AudioPlayerContext } from "../../context/AudioPlayer/AudioPlayerContext";
import { CircularProgress } from "@material-ui/core";
import { useParams, useHistory } from 'react-router-dom';
import { downloadResource } from "../../utils";
import Template from "./templates";
import { usePdfViewer } from "../../hooks/usePdfViewer";
import { inserirEmOrdem, ordenarMensagens } from "../../utils/messageOrder";

const useStyles = makeStyles((theme) => ({
  messagesListWrapper: {
    overflow: "hidden",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    width: "100%",
    minWidth: 300,
    minHeight: 200,
  },

  currentTick: {
    alignItems: "center",
    textAlign: "center",
    alignSelf: "center",
    width: "95%",
    backgroundColor: theme.palette.primary.main,
    margin: "10px",
    borderRadius: "10px",
    boxShadow: "1px 5px 10px #b3b3b3",
  },

  // #4292 — faixa da observacao do contato, no comeco da conversa. Rola junto
  // com o conteudo: grudada no topo (sticky) ela "descia a tela" e atrapalhava
  // a leitura das mensagens.
  contactNotesBanner: {
    flexShrink: 0,
    alignSelf: "center",
    width: "95%",
    boxSizing: "border-box",
    backgroundColor: theme.mode === "light" ? "#fff8e1" : "#3a3320",
    border: `1px solid ${theme.mode === "light" ? "#ffe082" : "#5c5030"}`,
    borderRadius: 10,
    margin: "8px 0",
    padding: "6px 10px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.15)"
  },

  contactNotesHeader: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "0.8rem"
  },

  contactNotesBody: {
    marginTop: 6,
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    fontSize: "0.85rem",
    maxHeight: 160,
    overflowY: "auto"
  },

  currentTicktText: {
    color: theme.palette.primary,
    fontWeight: 'bold',
    padding: 8,
    alignSelf: "center",
    marginLeft: "0px",
  },

  messagesList: {
    backgroundImage: theme.mode === 'light' ? `url(${whatsBackground})` : `url(${whatsBackgroundDark})`,
    backgroundColor: theme.mode === 'light' ? "transparent" : "#0b0b0d",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    padding: "20px 20px 30px 20px",
    overflowY: "scroll",
    ...theme.scrollbarStyles,
  },
  dragElement: {
    background: 'rgba(255, 255, 255, 0.8)',
    position: "absolute",
    width: "100%",
    height: "100%",
    zIndex: 999999,
    textAlign: "center",
    fontSize: "3em",
    border: "5px dashed #333",
    color: '#333',
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  dropProcessingOverlay: {
    background: 'rgba(255, 255, 255, 0.85)',
    position: "absolute",
    width: "100%",
    height: "100%",
    zIndex: 999999,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: 12,
    color: '#333',
  },
  circleLoading: {
    color: blue[500],
    position: "absolute",
    opacity: "70%",
    top: 0,
    left: "50%",
    marginTop: 12,
  },

  messageLeft: {
    marginRight: 20,
    marginTop: 2,
    minWidth: 100,
    maxWidth: 600,
    height: "auto",
    display: "block",
    position: "relative",
    "&:hover #messageActionsButton": {
      display: "flex",
      position: "absolute",
      top: 0,
      right: 0,
    },

    whiteSpace: "pre-wrap",
    backgroundColor: theme.mode === 'light' ? "#ffffff" : "#202c33",
    color: theme.mode === 'light' ? "#303030" : "#ffffff",
    alignSelf: "flex-start",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    paddingLeft: 5,
    paddingRight: 5,
    paddingTop: 5,
    paddingBottom: 0,
    boxShadow: theme.mode === 'light' ? "0 1px 1px #b3b3b3" : "0 1px 1px #000000"
  },

  quotedContainerLeft: {
    margin: "-3px -80px 6px -6px",
    overflow: "hidden",
    backgroundColor: theme.mode === 'light' ? "#f0f0f0" : "#1d282f",
    borderRadius: "7.5px",
    display: "flex",
    position: "relative",
  },

  quotedMsg: {
    padding: 10,
    maxWidth: 300,
    height: "auto",
    display: "block",
    whiteSpace: "pre-wrap",
    overflow: "hidden",
  },

  quotedSideColorLeft: {
    flex: "none",
    width: "4px",
    backgroundColor: "#388aff",
  },

  messageRight: {
    marginLeft: 20,
    marginTop: 2,
    minWidth: 100,
    maxWidth: 600,
    height: "auto",
    display: "block",
    position: "relative",
    "&:hover #messageActionsButton": {
      display: "flex",
      position: "absolute",
      top: 0,
      right: 0,
    },
    whiteSpace: "pre-wrap",
    backgroundColor: theme.mode === 'light' ? "#dcf8c6" : "#005c4b",
    color: theme.mode === 'light' ? "#303030" : "#ffffff",
    alignSelf: "flex-end",
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 0,
    paddingLeft: 5,
    paddingRight: 5,
    paddingTop: 5,
    paddingBottom: 0,
    boxShadow: theme.mode === 'light' ? "0 1px 1px #b3b3b3" : "0 1px 1px #000000"
  },

  messageRightPrivate: {
    marginLeft: 20,
    marginTop: 2,
    minWidth: 100,
    maxWidth: 600,
    height: "auto",
    display: "block",
    position: "relative",
    "&:hover #messageActionsButton": {
      display: "flex",
      position: "absolute",
      top: 0,
      right: 0,
    },
    whiteSpace: "pre-wrap",
    backgroundColor: "#F0E68C",
    color: "#303030",
    alignSelf: "flex-end",
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 0,
    paddingLeft: 5,
    paddingRight: 5,
    paddingTop: 5,
    paddingBottom: 0,
    boxShadow: theme.mode === 'light' ? "0 1px 1px #b3b3b3" : "0 1px 1px #000000"
  },

  quotedContainerRight: {
    margin: "-3px -80px 6px -6px",
    overflowY: "hidden",
    backgroundColor: theme.mode === 'light' ? "#cfe9ba" : "#025144",
    borderRadius: "7.5px",
    display: "flex",
    position: "relative",
  },

  quotedMsgRight: {
    padding: 10,
    maxWidth: 300,
    height: "auto",
    whiteSpace: "pre-wrap",
  },

  quotedSideColorRight: {
    flex: "none",
    width: "4px",
    backgroundColor: "#35cd96",
  },

  messageActionsButton: {
    display: "none",
    position: "relative",
    color: "#999",
    zIndex: 1,
    backgroundColor: "inherit",
    opacity: "90%",
    "&:hover, &.Mui-focusVisible": { backgroundColor: "inherit" },
  },

  /**
   * #4195: linha da mensagem própria — botão "Reenviar" à ESQUERDA do balão.
   *
   * O balão é filho direto de um flex column, então antes não havia onde
   * encaixar algo ao lado dele. Este wrapper cria a linha; o alinhamento à
   * direita, que era do balão (alignSelf), passa a ser do wrapper.
   */
  messageRowRight: {
    display: "flex",
    flexDirection: "row",
    alignItems: "stretch",
    alignSelf: "flex-end",
    justifyContent: "flex-end",
    maxWidth: "100%",
    // Assume a margem esquerda que o balão acoplado abre mão (ver
    // messageRightCoupled), para a linha não encostar na borda da lista.
    marginLeft: 20,
    // Sem gap: o botão é ACOPLADO ao balão, colado nele, separado apenas por
    // uma borda divisória (ver resendButton).
  },

  /**
   * Faixa "Reenviar" acoplada à esquerda do balão — não é um botão solto.
   *
   * Espelha o balão: mesmos cantos arredondados do lado esquerdo, cantos
   * direitos retos (encostam no balão) e um separador vertical entre os dois.
   * `alignItems: stretch` no wrapper faz a faixa acompanhar a altura do balão.
   */
  resendButton: {
    flexShrink: 0,
    minWidth: "auto",
    color: "#e53935",
    backgroundColor: theme.mode === "light" ? "#ffe3e1" : "#4a2320",
    textTransform: "none",
    whiteSpace: "nowrap",
    padding: "0 10px",
    fontSize: 12,
    fontWeight: 600,
    lineHeight: 1.4,
    borderRadius: "8px 0 0 8px",
    // O separador entre a faixa e o balão. Como os dois têm o mesmo fundo
    // vermelho, a divisória precisa de contraste para continuar legível.
    borderRight: `1px solid ${theme.mode === "light" ? "#e08e89" : "#7d443e"}`,
    boxShadow: "none",
    "& .MuiButton-startIcon": {
      marginRight: 4,
      marginLeft: 0,
    },
    "&:hover": {
      backgroundColor: theme.mode === "light" ? "#ffcdd2" : "#5c2b27",
      boxShadow: "none",
    },
  },

  // Balão com a faixa acoplada: canto esquerdo reto e sem a margem da esquerda
  // (que abriria um vão de 20px entre a faixa e o balão). O fundo vermelho
  // sinaliza a falha no balão inteiro, não só na faixa.
  messageRightCoupled: {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    marginLeft: 0,
    backgroundColor: theme.mode === "light" ? "#ffe3e1" : "#4a2320",
  },

  reactionsContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: 2,
    marginTop: -4,
    marginLeft: 4,
    marginBottom: 2,
  },

  reactionBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: 2,
    fontSize: 13,
    padding: "2px 6px",
    borderRadius: 16,
    backgroundColor: theme.mode === "light" ? "#ffffff" : "#1f2c33",
    boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
    cursor: "default",
    lineHeight: "18px",
  },

  reactionEmoji: {
    fontSize: 16,
  },

  reactionCount: {
    fontSize: 11,
    color: theme.mode === "light" ? "#555" : "#ccc",
    fontWeight: 500,
  },

  messageContactName: {
    display: "flex",
    color: "#6bcbef",
    fontWeight: 500,
  },

  textContentItem: {
    overflowWrap: "break-word",
    // O padding inferior (22) reserva a faixa do rodapé, onde ficam o horário
    // e o ícone de reenviar — ambos absolute. Sem ele, numa mensagem de uma
    // linha o rodapé encostava no texto e na seta do menu de ações (#4195).
    padding: "3px 80px 22px 6px",
    minHeight: 26,
    position: "relative",
  },

  textContentItemMedia: {
    overflowWrap: "break-word",
    padding: "3px 80px 6px 6px",
    minHeight: 18,
    position: "relative",
  },

  textContentItemDeleted: {
    fontStyle: "italic",
    color: "rgba(0, 0, 0, 0.36)",
    overflowWrap: "break-word",
    padding: "3px 80px 6px 6px",
  },

  messageMedia: {
    width: 400,
    height: "auto",
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    "&[controls]": {
      objectFit: "contain",
    }
  },

  videoContainer: {
    maxWidth: 440,
    width: "100%",
    position: "relative",
    borderRadius: 8,
    overflow: "hidden",
    backgroundColor: "#000",
    cursor: "pointer",
    "&:hover $videoPlayOverlay": {
      transform: "translate(-50%, -50%) scale(1.1)",
    },
  },
  videoThumbnail: {
    width: "100%",
    height: "auto",
    maxHeight: 360,
    display: "block",
    objectFit: "contain",
    backgroundColor: "#000",
  },
  videoPlayOverlay: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 52,
    height: 52,
    borderRadius: "50%",
    backgroundColor: "rgba(0,0,0,0.55)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "transform 0.2s ease, background-color 0.2s ease",
    backdropFilter: "blur(4px)",
    "& svg": {
      color: "#fff",
      fontSize: 30,
      marginLeft: 2,
    },
  },
  videoPlayingBadge: {
    position: "absolute",
    top: 8,
    left: 8,
    display: "flex",
    alignItems: "center",
    gap: 4,
    backgroundColor: "rgba(0,0,0,0.6)",
    borderRadius: 12,
    padding: "3px 8px 3px 5px",
    backdropFilter: "blur(4px)",
    "& svg": {
      color: "#fff",
      fontSize: 14,
    },
  },
  videoPlayingText: {
    color: "#fff",
    fontSize: "0.65rem",
    fontWeight: 500,
    letterSpacing: 0.3,
  },
  videoPlayingDot: {
    width: 6,
    height: 6,
    borderRadius: "50%",
    backgroundColor: "#ff4444",
    animation: "$pulse 1.5s ease-in-out infinite",
  },
  "@keyframes pulse": {
    "0%, 100%": { opacity: 1 },
    "50%": { opacity: 0.3 },
  },
  videoDuration: {
    position: "absolute",
    bottom: 8,
    left: 8,
    display: "flex",
    alignItems: "center",
    gap: 3,
    backgroundColor: "rgba(0,0,0,0.6)",
    borderRadius: 8,
    padding: "2px 6px",
    backdropFilter: "blur(4px)",
    "& svg": {
      color: "#fff",
      fontSize: 12,
    },
  },
  videoDurationText: {
    color: "#fff",
    fontSize: "0.65rem",
    fontVariantNumeric: "tabular-nums",
  },
  videoDownloadBtn: {
    position: "absolute",
    bottom: 6,
    right: 6,
    backgroundColor: "rgba(0,0,0,0.5)",
    color: "#fff",
    padding: 5,
    backdropFilter: "blur(4px)",
    "&:hover": {
      backgroundColor: "rgba(0,0,0,0.7)",
    },
    "& svg": {
      fontSize: 16,
    },
  },
  videoErrorContainer: {
    padding: 20,
    textAlign: "center",
    backgroundColor: theme.palette.action.hover,
    borderRadius: 8,
    color: theme.palette.text.secondary,
    maxWidth: 440,
  },
  videoLoadingOverlay: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 2,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 6,
  },
  // Custom inline video player controls
  inlineVideoWrapper: {
    maxWidth: 440,
    minWidth: 280,
    width: "100%",
    position: "relative",
    borderRadius: 8,
    overflow: "hidden",
    backgroundColor: "#000",
    "&:hover $videoControlsOverlay": {
      opacity: 1,
    },
  },
  inlineVideo: {
    width: "100%",
    height: "auto",
    maxHeight: 360,
    minHeight: 120,
    display: "block",
    objectFit: "contain",
    backgroundColor: "#000",
    cursor: "pointer",
  },
  videoControlsOverlay: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    background: "linear-gradient(transparent, rgba(0,0,0,0.75))",
    opacity: 0,
    transition: "opacity 0.25s ease",
    zIndex: 3,
    display: "flex",
    flexDirection: "column",
    padding: "16px 8px 6px 8px",
  },
  videoProgressRow: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    padding: "0 2px",
    marginBottom: 2,
  },
  videoProgressSlider: {
    flex: 1,
    color: "#fff",
    padding: "6px 0",
    "& .MuiSlider-rail": {
      height: 3,
      borderRadius: 2,
      opacity: 0.4,
      backgroundColor: "rgba(255,255,255,0.5)",
    },
    "& .MuiSlider-track": {
      height: 3,
      borderRadius: 2,
    },
    "& .MuiSlider-thumb": {
      width: 12,
      height: 12,
      marginTop: -4.5,
      backgroundColor: "#fff",
      "&:hover, &.Mui-focusVisible": {
        boxShadow: "0 0 0 6px rgba(255,255,255,0.25)",
      },
    },
  },
  videoControlsRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 2px",
  },
  videoControlsLeft: {
    display: "flex",
    alignItems: "center",
    gap: 2,
  },
  videoControlsRight: {
    display: "flex",
    alignItems: "center",
    gap: 2,
  },
  videoControlBtn: {
    color: "#fff",
    padding: 5,
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.15)",
    },
    "& svg": {
      fontSize: 22,
    },
  },
  videoTimeText: {
    color: "rgba(255,255,255,0.9)",
    fontSize: "0.72rem",
    fontVariantNumeric: "tabular-nums",
    minWidth: 36,
    textAlign: "center",
    userSelect: "none",
    whiteSpace: "nowrap",
  },
  // Big play/pause overlay for center of video
  videoBigPlayOverlay: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 56,
    height: 56,
    borderRadius: "50%",
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: "opacity 0.3s ease, transform 0.2s ease",
    backdropFilter: "blur(4px)",
    "&:hover": {
      transform: "translate(-50%, -50%) scale(1.08)",
      backgroundColor: "rgba(0,0,0,0.65)",
    },
    "& svg": {
      color: "#fff",
      fontSize: 32,
      marginLeft: 2,
    },
  },

  timestamp: {
    fontSize: 11,
    position: "absolute",
    bottom: 2,
    right: 5,
    color: "#999",
    // #4195 — o ícone de reenviar mora DENTRO deste span, que é absolute e
    // ancorado no rodapé do balão. Aumentar só a altura do card não bastava:
    // com `bottom: 0` o span (e o ícone) continuava colado na borda, sem área
    // de clique confortável. O afastamento vem daqui.
    //
    // zIndex acima do botão de ações (que tem 1) — sem isto ele se sobrepunha
    // a este canto em mensagens curtas e roubava o clique.
    zIndex: 2,
    display: "flex",
    alignItems: "center",
    gap: 3,
    lineHeight: 1,
  },

  pendingFragmentMessage: {
    color: "#667781",
    fontSize: "13px",
    fontStyle: "normal",
    display: "flex",
    alignItems: "flex-start",
    gap: "6px",
    lineHeight: "19px",
  },

  pendingFragmentIcon: {
    width: "16px !important",
    height: "16px !important",
    marginTop: "2px",
    color: "#667781 !important",
  },

  forwardMessage: {
    fontSize: 12,
    fontStyle: "italic",
    position: "absolute",
    top: 0,
    left: 5,
    color: "#999",
    display: "flex",
    alignItems: "center"
  },

  dailyTimestamp: {
    alignItems: "center",
    textAlign: "center",
    alignSelf: "center",
    width: "110px",
    backgroundColor: "#e1f3fb",
    margin: "10px",
    borderRadius: "10px",
    boxShadow: "0 1px 1px #b3b3b3",
  },

  dailyTimestampText: {
    color: "#808888",
    padding: 8,
    alignSelf: "center",
    marginLeft: "0px",
  },

  ackIcons: {
    fontSize: 18,
    verticalAlign: "middle",
    marginLeft: 4,
  },

  deletedIcon: {
    fontSize: 18,
    verticalAlign: "middle",
    marginRight: 4,
  },

  ackDoneAllIcon: {
    color: blue[500],
    fontSize: 18,
    verticalAlign: "middle",
    marginLeft: 4,
  },

  ackPlayedIcon: {
    color: green[500],
    fontSize: 18,
    verticalAlign: "middle",
    marginLeft: 4,
  },
  downloadMedia: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "inherit",
    padding: 10,
    color: theme.mode === "light" ? theme.palette.light : theme.palette.dark,
  },

  // Card de arquivo genérico (.txt/.docx/.json/.md/etc) — antes caía num
  // botão "Download" sem nome nem extensão (#4227). Mostra ícone, nome real do
  // arquivo e a extensão em destaque, no mesmo espírito do preview de PDF.
  fileCard: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "10px 12px",
    margin: 4,
    maxWidth: 300,
    borderRadius: 8,
    cursor: "pointer",
    backgroundColor: theme.mode === "light" ? "rgba(0,0,0,0.04)" : "rgba(255,255,255,0.06)",
    "&:hover": {
      backgroundColor: theme.mode === "light" ? "rgba(0,0,0,0.08)" : "rgba(255,255,255,0.10)",
    },
  },
  fileCardIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 40,
    height: 40,
    flexShrink: 0,
    borderRadius: 6,
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    textTransform: "uppercase",
    fontSize: 11,
    fontWeight: 700,
  },
  fileCardInfo: {
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
  },
  fileCardName: {
    fontSize: 13,
    fontWeight: 500,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  fileCardHint: {
    fontSize: 11,
    opacity: 0.7,
  },

  messageCenter: {
    // #4195 — âncora do messageActionsButton, que virou absolute.
    position: "relative",
    marginTop: 5,
    alignItems: "center",
    verticalAlign: "center",
    alignContent: "center",
    backgroundColor: "#E1F5FEEB",
    fontSize: "12px",
    minWidth: 100,
    maxWidth: 270,
    color: "#272727",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    paddingLeft: 5,
    paddingRight: 5,
    paddingTop: 5,
    paddingBottom: 0,
    boxShadow: "0 1px 1px #b3b3b3",
  },

  deletedMessage: {
    color: '#f55d65'
  }
}));

const formatVideoTime = (seconds) => {
  if (!seconds || isNaN(seconds)) return "0:00";
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs.toString().padStart(2, "0")}`;
};

/**
 * Inline video player that renders inside the message bubble.
 * Assigns itself to the global audioRef so the GlobalAudioPlayer
 * can take over seamlessly when the user navigates away.
 */
const InlineVideoPlayer = ({ src }) => {
  const classes = useStyles();
  const {
    audioRef,
    seekTimeRef,
    isPlaying,
    setIsPlaying,
  } = useContext(AudioPlayerContext);
  const videoRef = useRef(null);
  const unmountingRef = useRef(false);
  const animFrameRef = useRef(null);
  const hideTimerRef = useRef(null);

  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [seeking, setSeeking] = useState(false);
  const [muted, setMuted] = useState(false);
  const [showBigPlay, setShowBigPlay] = useState(true);
  const [controlsVisible, setControlsVisible] = useState(false);

  // Time sync via requestAnimationFrame
  useEffect(() => {
    const update = () => {
      if (videoRef.current && !seeking) {
        setCurrentTime(videoRef.current.currentTime);
        const dur = videoRef.current.duration;
        if (dur && isFinite(dur)) setDuration(dur);
      }
      animFrameRef.current = requestAnimationFrame(update);
    };
    animFrameRef.current = requestAnimationFrame(update);
    return () => {
      if (animFrameRef.current) cancelAnimationFrame(animFrameRef.current);
    };
  }, [seeking]);

  // Video setup & global ref assignment
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    unmountingRef.current = false;

    // Point the global ref to this inline element
    audioRef.current = video;

    const onLoadedMetadata = () => {
      if (video.duration && isFinite(video.duration)) {
        setDuration(video.duration);
      }
      // Seek to saved position from global player handoff
      if (seekTimeRef.current !== null) {
        video.currentTime = seekTimeRef.current;
        seekTimeRef.current = null;
      }
      video.play().catch(() => {});
    };

    const onEnded = () => {
      setIsPlaying(false);
      setShowBigPlay(true);
    };
    const onPause = () => {
      if (!unmountingRef.current) {
        setIsPlaying(false);
        setShowBigPlay(true);
      }
    };
    const onPlay = () => {
      setIsPlaying(true);
      setShowBigPlay(false);
    };

    video.addEventListener("loadedmetadata", onLoadedMetadata);
    video.addEventListener("ended", onEnded);
    video.addEventListener("pause", onPause);
    video.addEventListener("play", onPlay);

    if (video.readyState >= 1) {
      onLoadedMetadata();
    }

    return () => {
      unmountingRef.current = true;
      // Save current time so the global player can resume
      if (video.currentTime > 0) {
        seekTimeRef.current = video.currentTime;
      }
      video.removeEventListener("loadedmetadata", onLoadedMetadata);
      video.removeEventListener("ended", onEnded);
      video.removeEventListener("pause", onPause);
      video.removeEventListener("play", onPlay);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [src]);

  const togglePlay = () => {
    if (!videoRef.current) return;
    if (videoRef.current.paused) {
      videoRef.current.play().catch(() => {});
    } else {
      videoRef.current.pause();
    }
  };

  const handleSliderChange = (_, value) => {
    setSeeking(true);
    setCurrentTime(value);
  };

  const handleSliderCommitted = (_, value) => {
    if (videoRef.current) {
      videoRef.current.currentTime = value;
    }
    setSeeking(false);
  };

  const toggleMute = (e) => {
    e.stopPropagation();
    if (videoRef.current) {
      videoRef.current.muted = !videoRef.current.muted;
      setMuted(videoRef.current.muted);
    }
  };

  const handleFullscreen = (e) => {
    e.stopPropagation();
    if (videoRef.current) {
      if (videoRef.current.requestFullscreen) {
        videoRef.current.requestFullscreen();
      } else if (videoRef.current.webkitEnterFullscreen) {
        videoRef.current.webkitEnterFullscreen();
      }
    }
  };

  // Show controls on hover/tap, auto-hide after 3s
  const showControls = () => {
    setControlsVisible(true);
    if (hideTimerRef.current) clearTimeout(hideTimerRef.current);
    hideTimerRef.current = setTimeout(() => {
      if (!seeking) setControlsVisible(false);
    }, 3000);
  };

  const alwaysShow = !isPlaying || controlsVisible;

  return (
    <div
      className={classes.inlineVideoWrapper}
      onMouseEnter={showControls}
      onMouseMove={showControls}
      onMouseLeave={() => {
        if (!seeking) setControlsVisible(false);
      }}
    >
      <video
        ref={videoRef}
        className={classes.inlineVideo}
        src={src}
        preload="auto"
        playsInline
        onClick={togglePlay}
      />

      {/* Big center play/pause button */}
      {showBigPlay && (
        <div className={classes.videoBigPlayOverlay} onClick={togglePlay}>
          <PlayArrowIcon />
        </div>
      )}

      {/* Controls overlay: progress row + buttons row */}
      <div
        className={classes.videoControlsOverlay}
        style={alwaysShow ? { opacity: 1 } : undefined}
      >
        {/* Progress slider row */}
        <div className={classes.videoProgressRow}>
          <Typography className={classes.videoTimeText}>
            {formatVideoTime(currentTime)}
          </Typography>
          <Slider
            className={classes.videoProgressSlider}
            min={0}
            max={duration || 1}
            value={currentTime}
            onChange={handleSliderChange}
            onChangeCommitted={handleSliderCommitted}
            step={0.1}
          />
          <Typography className={classes.videoTimeText}>
            {formatVideoTime(duration)}
          </Typography>
        </div>

        {/* Buttons row */}
        <div className={classes.videoControlsRow}>
          <div className={classes.videoControlsLeft}>
            <IconButton className={classes.videoControlBtn} size="small" onClick={togglePlay}>
              {isPlaying ? <PauseIcon /> : <PlayArrowIcon />}
            </IconButton>
            <IconButton className={classes.videoControlBtn} size="small" onClick={toggleMute}>
              {muted ? <VolumeOffIcon /> : <VolumeUpIcon />}
            </IconButton>
          </div>
          <div className={classes.videoControlsRight}>
            <IconButton
              className={classes.videoControlBtn}
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                const link = document.createElement("a");
                link.href = src;
                link.download = "video.mp4";
                link.click();
              }}
              title="Baixar vídeo"
            >
              <GetApp />
            </IconButton>
            <IconButton className={classes.videoControlBtn} size="small" onClick={handleFullscreen}>
              <FullscreenIcon />
            </IconButton>
          </div>
        </div>
      </div>
    </div>
  );
};

const reducer = (state, action) => {
  if (action.type === "LOAD_MESSAGES") {
    const messages = action.payload;
    const newMessages = [];

    messages.forEach((message) => {

      const messageIndex = state.findIndex((m) => m.id === message.id);
      if (messageIndex !== -1) {
        state[messageIndex] = message;
      } else {
        newMessages.push(message);
      }
    });

    // #4340: o lote carregado pode trazer mensagens reentregues fora de ordem;
    // ordena por data em vez de confiar na ordem de chegada.
    return ordenarMensagens([...newMessages, ...state]);
  }

  if (action.type === "ADD_MESSAGE") {
    const newMessage = action.payload;
    const messageIndex = state.findIndex((m) => m.id === newMessage.id);

    if (messageIndex !== -1) {
      state[messageIndex] = newMessage;
      return [...state];
    }

    // #4340: era `state.push(...)` — toda mensagem do socket ia para o fim,
    // logo era desenhada como a mais recente. Uma mensagem reentregue depois
    // de um restart tem createdAt de dias atrás e aparecia embaixo do bloco
    // "Hoje", bagunçando também as tarjas de data. Entra na posição
    // cronológica; para a mensagem realmente nova, o custo é o mesmo do push.
    return inserirEmOrdem(state, newMessage);
  }

  if (action.type === "UPDATE_MESSAGE") {
    const messageToUpdate = action.payload;
    const messageIndex = state.findIndex((m) => m.id === messageToUpdate.id);

    if (messageIndex !== -1) {
      // #4155: ver mergedHistory.js — o update de ACK traz o ticket PARCIAL
      // (sem queue/whatsapp) e não pode apagar o que já temos.
      state[messageIndex] = mergeUpdatedMessage(state[messageIndex], messageToUpdate);
    }

    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }
};

const MessagesList = ({
  isGroup,
  onDrop,
  dropProcessingReset,
  whatsappId,
  queueId,
  channel,
  ticketStatus,
  // #4241: id e fila do ticket ABERTO, vindos do componente Ticket (que os
  // mantém atualizados pelo socket). A faixa usa isso para não ficar presa na
  // fila que estava gravada nas mensagens já carregadas.
  openTicketId,
  openTicketQueue,
  openTicketQueueId,
  // #4292 — observacao do contato (texto unico, vale para todo atendimento)
  contactNotes,
  contactNotesExpanded
}) => {
  const classes = useStyles();
  // #4292 — como a faixa nasce vem do contato (notesExpanded). Ao trocar de
  // ticket volta ao estado configurado: o que o atendente abriu/fechou na mao
  // nao vaza de um atendimento para outro.
  const [notesCollapsed, setNotesCollapsed] = useState(!contactNotesExpanded);
  // #4292 — a faixa entra UMA vez, na altura em que a conversa estava ao
  // abrir: fixa o id da ultima mensagem daquele momento. O que chegar depois
  // aparece ABAIXO dela, como uma mensagem qualquer — a observacao nao fica
  // "perseguindo" o fim da conversa enquanto o atendimento acontece.
  const notesAfterMessageId = useRef(null);
  useEffect(() => {
    setNotesCollapsed(!contactNotesExpanded);
  }, [openTicketId, contactNotesExpanded]);

  // Ticket novo: solta a ancora para ser refeita no proximo carregamento.
  useEffect(() => {
    notesAfterMessageId.current = null;
  }, [openTicketId]);
  // Gate de hot path: só monta o PluginBridge na bolha se algum plugin declarou
  // o slot. Evita render à toa nas centenas de mensagens.
  const hasMsgContentSlot = useHasSlot(ticketsUI.slots.MESSAGE_CONTENT);
  const hasMsgFooterSlot = useHasSlot(ticketsUI.slots.MESSAGE_FOOTER);
  // Card de arquivo (#4227): um plugin pode renderizar um card próprio no slot
  // MESSAGE_FILE_CARD e, declarando o hook, substituir o card nativo.
  const hasFileCardSlot = useHasSlot(ticketsUI.slots.MESSAGE_FILE_CARD);
  // Faixa separadora de tickets (#4155): um plugin pode somar informação nela
  // ou, com o hook, substituir a faixa nativa.
  const hasTicketSeparatorSlot = useHasSlot(ticketsUI.slots.MESSAGE_TICKET_SEPARATOR);
  // Faixa de reações: canal cujo emoji é imagem desenha a sua (Discord).
  const hasReactionsSlot = useHasSlot(ticketsUI.slots.MESSAGE_REACTIONS);
  const { shouldHide } = usePluginBridge();
  const { inserirNoRascunho } = useDraftInsert();
  const [messagesList, dispatch] = useReducer(reducer, []);

  const [pageNumber, setPageNumber] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [hasMoreHistory, setHasMoreHistory] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [loadingHistory, setLoadingHistory] = useState(false);
  const history = useHistory();
  const lastMessageRef = useRef();

  const [selectedMessage, setSelectedMessage] = useState({});
  const { setReplyingMessage } = useContext(ReplyMessageContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const messageOptionsMenuOpen = Boolean(anchorEl);
  const { ticketId } = useParams();

  // #4155: ticketId -> { queue, whatsapp }, recalculado só quando a lista muda.
  // A faixa consulta em O(1) em vez de varrer as mensagens a cada separador.
  const ticketDataIndex = useMemo(
    () => buildTicketDataIndex(messagesList),
    [messagesList]
  );

  const currentTicketId = useRef(ticketId);
  // #4155: dados do ticket ABERTO (contato/grupo), usados para reconhecer em
  // tempo real as mensagens de outros tickets do mesmo contato quando o
  // histórico está mesclado. Vem do próprio ticket devolvido pelo /messages.
  const currentTicketRef = useRef(null);
  // #4080: trava contra pedir a mesma próxima página duas vezes (ver `checar`).
  const pedidoEmVooRef = useRef(false);
  const { getAll } = useCompanySettings();
  const [dragActive, setDragActive] = useState(false);
  const [dropProcessing, setDropProcessing] = useState(false);

  const [videoLoading, setVideoLoading] = useState(true);
  const [videoError, setVideoError] = useState(false);
  const [videoDuration, setVideoDuration] = useState(0);
  const videoThumbRef = useRef(null);

  // #4192 item 2: tick para reavaliar mensagens presas em ack=0 (relógio) sem
  // esperar o socket/refresh — sem isto o ícone só mudaria de relógio pra
  // falha em uma re-renderização causada por outro evento (nova msg, etc), o
  // que podia demorar minutos numa conversa parada. Espelha o timeout do
  // FailStuckMessagesJob no backend (90s) só como sinal visual antecipado;
  // o botão de reenvio já funciona a partir daqui (ver handleResend).
  const [, forceAckTick] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => forceAckTick((t) => t + 1), 15000);
    return () => clearInterval(interval);
  }, []);

  const [lgpdDeleteMessage, setLGPDDeleteMessage] = useState(false);
  const [transcriptionEnabled, setTranscriptionEnabled] = useState(false);
  // #4155: com o histórico mesclado, a lista mostra as conversas de OUTROS
  // tickets do contato. Precisa saber disso aqui para aceitar em tempo real as
  // mensagens que chegam nesses tickets — senão só apareceriam ao recarregar.
  const [mergeHistoryByContact, setMergeHistoryByContact] = useState(false);
  const { selectedQueuesMessage } = useContext(QueueSelectedContext);

  // Hook simplificado para PDF
  const {
    downloadPdf,
    extractPdfInfoFromMessage,
    isPdfUrl
  } = usePdfViewer();

  const { showSelectMessageCheckbox } = useContext(ForwardMessageContext);
  const { user, socket } = useContext(AuthContext);
  const companyId = user.companyId;
  const audioPlayerCtx = useContext(AudioPlayerContext);

  useEffect(() => {
    async function fetchData() {
      const settings = await getAll(companyId);

      let settinglgpdDeleteMessage;
      let settingEnableLGPD;

      for (const [key, value] of Object.entries(settings)) {
        if (key === "lgpdDeleteMessage") settinglgpdDeleteMessage = value
        if (key === "enableLGPD") settingEnableLGPD = value
        if (key === "openaiToken") setTranscriptionEnabled(!!value)
      }
      if (settingEnableLGPD === "enabled" && settinglgpdDeleteMessage === "enabled") {
        setLGPDDeleteMessage(true);
      }

      // #4155: mergeHistoryByContact vive na tabela Settings (GET /settings),
      // NÃO em CompaniesSettings (o getAll acima) — são dois sistemas de
      // configuração distintos. Lido do getAll, o valor vinha undefined e o
      // filtro do socket rejeitava as mensagens dos outros tickets do contato.
      try {
        const { data } = await api.get("/settings");
        const merge = (Array.isArray(data) ? data : []).find(
          s => s.key === "mergeHistoryByContact"
        );
        setMergeHistoryByContact(merge?.value === "true");
      } catch (err) {
        // sem o setting o fio segue isolado por ticket (comportamento antigo)
      }
    }
    fetchData();
  }, [])

  useEffect(() => {
    dispatch({ type: "RESET" });
    setPageNumber(1);
    setHasMoreHistory(false);
    currentTicketId.current = ticketId;
  }, [ticketId, selectedQueuesMessage]);

  useEffect(() => {
    if (ticketId === "undefined") {
      history.push("/tickets");
      return;
    }
    if (isNil(ticketId)) return;

    setLoading(true);
    const fetchMessages = async () => {
      try {
        const { data } = await api.get("/messages/" + ticketId, {
          params: { pageNumber, selectedQueues: JSON.stringify(selectedQueuesMessage) },
        });

        // #4155: guarda contato/grupo do ticket aberto para o filtro do socket.
        // FORA do if de currentTicketId: esse ref é atualizado por outro effect,
        // que na primeira carga roda DEPOIS desta resposta — dentro do if, o
        // dado nunca era gravado e o filtro do socket rejeitava tudo.
        if (data.ticket?.uuid === ticketId) {
          currentTicketRef.current = {
            contactId: data.ticket.contactId,
            isGroup: data.ticket.isGroup
          };
        }

        if (currentTicketId.current === ticketId) {
          dispatch({ type: "LOAD_MESSAGES", payload: data.messages });
          setHasMore(data.hasMore);
          setHasMoreHistory(data.hasMoreHistory || false);
          setLoading(false);
          setLoadingMore(false);
        }
        // #4080: a página chegou — libera a trava para a próxima checagem.
        pedidoEmVooRef.current = false;

        if (pageNumber === 1 && data.messages.length > 1) {
          scrollToBottom();
        }
      } catch (err) {
        setLoading(false);
        toastError(err);
        setLoadingMore(false);
        // Libera também no erro, senão a lista trava de vez após uma falha.
        pedidoEmVooRef.current = false;
      }
    };

    fetchMessages();
  }, [pageNumber, ticketId, selectedQueuesMessage]);

  /**
   * #4080: carregar mais quando a lista NÃO tem barra de rolagem.
   *
   * Todo o carregamento dependia do evento onScroll. Com zoom alto cabem menos
   * mensagens na viewport, mas o page size do backend é fixo — a página não
   * enche o container, não há o que rolar, o evento nunca dispara e nada mais
   * carrega. Pior: o botão "carregar histórico" só aparece com `!hasMore`, que
   * só vira false depois de rolar até o fim das páginas. Sem scroll o usuário
   * ficava sem NENHUMA forma de buscar mensagens antigas.
   *
   * Aqui, depois de cada carga, se o conteúdo não preenche a área visível e
   * ainda há páginas, pede a próxima — até haver overflow (e então o scroll
   * normal assume) ou acabarem as páginas (e então o botão de histórico
   * aparece).
   */
  useEffect(() => {
    const el = document.getElementById("messagesList");
    if (!el) return;

    const checar = () => {
      if (loading || loadingMore || !hasMore) return;
      // A trava é uma ref (não estado): entre chamar loadMore() e o
      // `loadingMore` chegar aqui há um re-render, e nessa janela o observer
      // dispararia de novo. Como loadMore faz pageNumber+1, o pedido duplo
      // PULARIA uma página, cujo conteúdo nunca carregaria. A ref muda no ato.
      if (pedidoEmVooRef.current) return;
      // Margem de 1px: com zoom as métricas são fracionárias e scrollHeight
      // pode ficar um triz acima de clientHeight sem haver rolagem real.
      if (el.scrollHeight <= el.clientHeight + 1) {
        pedidoEmVooRef.current = true;
        loadMore();
      }
    };

    checar();

    // O overflow também pode sumir DEPOIS da carga — o usuário aumenta o zoom
    // ou redimensiona a janela e o que rolava deixa de rolar. Um efeito preso
    // aos dados não veria isso; o observer reavalia a cada mudança de tamanho.
    if (typeof ResizeObserver === "undefined") return;

    // O callback roda DENTRO do ciclo de layout: chamar loadMore() ali insere
    // mensagens, que mudam o tamanho, que redisparam o observer — o navegador
    // aborta com "ResizeObserver loop completed with undelivered
    // notifications". O rAF adia para depois do ciclo, quebrando o laço.
    let frame = null;
    const observer = new ResizeObserver(() => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = null;
        checar();
      });
    });
    observer.observe(el);

    return () => {
      if (frame) cancelAnimationFrame(frame);
      observer.disconnect();
    };
  }, [messagesList, loading, loadingMore, hasMore]);

  useEffect(() => {
    // Socket pode ser nulo (logout forçado, instante antes de conectar): sem
    // isto o socket.on lançava e derrubava a tela inteira (11-09-2026).
    if (!socket) return undefined;
    if (!ticketId || ticketId === "undefined") {
      return;
    }

    const companyId = user.companyId;

    const connectEventMessagesList = () => {
      socket.emit("joinChatBox", `${ticketId}`);
    }

    // #4068: marca lido na chegada da mensagem — o evento já é o sinal de que
    // ela apareceu na tela. Pelo socket já conectado, sem custo de request.
    // best-effort: se falhar, a leitura volta a ser marcada ao reabrir o ticket.
    const markTicketAsRead = (id) => {
      socket.emit("ticket:read", { ticketId: id });
    };

    // Join imediatamente (não apenas no reconnect)
    socket.emit("joinChatBox", `${ticketId}`);

    // #4155: com o merge ligado o fio mostra as conversas de outros tickets do
    // MESMO contato/conexão. Sem isto, mensagem que chega num desses tickets só
    // apareceria ao recarregar — o fio ficaria parado enquanto o histórico
    // (recarregado) já a incluiria. Compara com o contato do ticket aberto,
    // que vem no ticket das mensagens já carregadas.
    const belongsToThisThread = (incomingTicket) =>
      belongsToThread({
        incomingTicket,
        openTicketUuid: ticketId,
        openTicket: currentTicketRef.current,
        mergeHistoryByContact
      });

    const onAppMessageMessagesList = (data) => {
      if (data.action === "create" && belongsToThisThread(data.ticket)) {
        dispatch({ type: "ADD_MESSAGE", payload: data.message });
        scrollToBottom();

        // #4068: a conversa está aberta na tela, então o atendente ESTÁ vendo
        // esta mensagem — avisa o backend para não contá-la como não lida.
        // Nenhuma outra rota de leitura roda neste momento (abrir o ticket e
        // listar mensagens são ações anteriores ao socket chegar).
        // Só mensagem do contato: o próprio eco não conta como não lida.
        // #4155: só marca leitura do ticket ABERTO. Com o merge, a mensagem
        // pode ser de outro ticket do contato (de outro atendente) — zerar o
        // não-lido dele apagaria o aviso de quem realmente precisa ver.
        if (!data.message?.fromMe && data.ticket.uuid === ticketId) {
          markTicketAsRead(data.ticket.id);
        }
      }

      if (data.action === "update" && belongsToThisThread(data?.message?.ticket)) {
        dispatch({ type: "UPDATE_MESSAGE", payload: data.message });
      }

      if (data.action == "delete" && belongsToThisThread(data.message?.ticket)) {
        dispatch({ type: "DELETE_MESSAGE", payload: data.messageId });
      }
    }
    socket.on("connect", connectEventMessagesList);
    socket.on(`company-${companyId}-appMessage`, onAppMessageMessagesList);

    return () => {
      socket.emit("joinChatBoxLeave", `${ticketId}`)
      socket.off("connect", connectEventMessagesList);
      socket.off(`company-${companyId}-appMessage`, onAppMessageMessagesList);
    };

    // #4155: mergeHistoryByContact entra nas deps porque o handler decide por
    // ele; sem isso a closure ficaria presa no valor inicial (false) e as
    // mensagens dos outros tickets do contato nunca chegariam ao vivo.
  }, [socket, ticketId, mergeHistoryByContact]);

  useEffect(() => {
    if (dropProcessingReset > 0) {
      setDropProcessing(false);
    }
  }, [dropProcessingReset]);

  const loadMore = () => {
    if (loadingMore) return;
    setLoadingMore(true);
    setPageNumber((prevPageNumber) => prevPageNumber + 1);
  };

  const loadOlderHistory = async () => {
    if (loadingHistory) return;
    if (!hasMoreHistory) return;
    const cursor = resolveHistoryCursor(messagesList);

    setLoadingHistory(true);
    const messagesListEl = document.getElementById("messagesList");
    const previousScrollHeight = messagesListEl.scrollHeight;
    const previousScrollTop = messagesListEl.scrollTop;

    try {
      const { data } = await api.get("/messages/" + ticketId, {
        params: {
          pageNumber: 1,
          selectedQueues: JSON.stringify(selectedQueuesMessage),
          oldestMessageTimestamp: cursor,
        },
      });

      dispatch({ type: "LOAD_MESSAGES", payload: data.messages });
      setHasMoreHistory(data.hasMoreHistory || false);

      requestAnimationFrame(() => {
        const newScrollHeight = messagesListEl.scrollHeight;
        messagesListEl.scrollTop = previousScrollTop + (newScrollHeight - previousScrollHeight);
      });
    } catch (err) {
      toastError(err);
    } finally {
      setLoadingHistory(false);
    }
  };

  const scrollToBottom = () => {
    setTimeout(() => {
      if (lastMessageRef.current) {
        lastMessageRef.current.scrollIntoView({});
      }
    }, 100);
  };

  const handleScroll = (e) => {
    if (!hasMore) return;
    const { scrollTop } = e.currentTarget;

    // #4080: com zoom as métricas são fracionárias — o topo pode reportar 0.5
    // em vez de 0, e a igualdade exata falhava. Sem este empurrão o container
    // fica grudado no topo e para de emitir eventos de scroll.
    if (scrollTop <= 1) {
      document.getElementById("messagesList").scrollTop = 1;
    }

    if (loading) {
      return;
    }

    if (scrollTop < 50) {
      loadMore();
    }
  };

  const handleOpenMessageOptionsMenu = (e, message) => {
    setAnchorEl(e.currentTarget);
    setSelectedMessage(message);
  };

  const handleContextMenu = (e, message) => {
    e.preventDefault();
    setAnchorEl(e.currentTarget);
    setSelectedMessage(message);
  };

  const handleCloseMessageOptionsMenu = (e) => {
    setAnchorEl(null);
  };

  const hanldeReplyMessage = (e, message) => {
    setAnchorEl(null);
    setReplyingMessage(message);
  };

  const getBasename = (filepath) => {
    if (!filepath) return '';
    // Remove query strings e hashes
    const cleanPath = filepath.split('?')[0].split('#')[0];
    // Pega o último segmento após /
    const segments = cleanPath.split('/');
    return segments[segments.length - 1];
  };

  const checkMessageMedia = (message) => {
    const isAudioMessage = (message) => {
      if (message.mediaType === "audio") {
        console.log("🎵 Detectado como áudio pelo mediaType:", message.mediaType);
        return true;
      }

      if (message.mediaUrl) {
        const audioExtensions = ['.mp3', '.wav', '.ogg', '.m4a', '.aac', '.webm'];
        const url = message.mediaUrl.toLowerCase();
        const hasAudioExtension = audioExtensions.some(ext => url.includes(ext));

        if (hasAudioExtension) {
          console.log("🎵 Detectado como áudio pela URL:", url);
          return true;
        }
      }

      if (message.body && typeof message.body === 'string') {
        const body = message.body.toLowerCase();
        const isAudioBody = body.includes('áudio gravado') ||
          body.includes('audio_') ||
          body.includes('🎵') ||
          body.includes('arquivo de áudio') ||
          body.includes('mensagem de voz');

        if (isAudioBody) {
          console.log("🎵 Detectado como áudio pelo body:", body);
          return true;
        }
      }

      return false;
    };

    // Mídia falhou no download → card único de retry para qualquer tipo
    if (message.fileStatus === "failed") {
      return (
        <MediaUnavailable
          messageId={message.id}
          filename={message.body || getBasename(message.mediaUrl)}
          mediaType={message.mediaType}
        />
      );
    }

    // Templates
    if (message.mediaType === "template") {
      return <Template message={message} />;
    }

    // Localização
    else if (message.mediaType === "locationMessage" && message.body.split('|').length >= 2) {
      let locationParts = message.body.split('|');
      let imageLocation = locationParts[0];
      let linkLocation = locationParts[1];
      let descriptionLocation = locationParts.length > 2 ? locationParts[2] : null;

      return <LocationPreview 
        image={imageLocation} 
        link={linkLocation} 
        description={descriptionLocation} 
      />;
    }

    // Contatos
    else if (message.mediaType === "contactMessage") {
      // Parser robusto: prioriza waid (número canônico do WhatsApp) sobre o TEL
      // formatado, que às vezes traz DDI duplicado. Ver utils/parseVcard.
      const { name, number } = parseVcard(message.body);

      return <VcardPreview
        contact={name}
        numbers={number}
        queueId={message?.ticket?.queueId}
        whatsappId={message?.ticket?.whatsappId}
        channel={channel}
      />;
    }

    else if (message.mediaType === "adMetaPreview") { // Adicionado para renderizar o componente de preview de anúncio
      console.log("Entrou no MetaPreview");
      // ✅ CORREÇÃO: Parse correto dos dados - formato: image|sourceUrl|title|body|messageUser
      let [image, sourceUrl, title, body, messageUser] = message.body.split('|');
      
      // Fallback para messageUser se não estiver presente
      if (!messageUser || messageUser.trim() === "") {
        messageUser = "Olá! Tenho interesse e queria mais informações, por favor.";
      }
      
      return <AdMetaPreview 
        image={image} 
        sourceUrl={sourceUrl} 
        title={title} 
        body={body} 
        messageUser={messageUser} 
      />;
    }

    // PDF e Documentos - SÓ DOWNLOAD
    else if (isPdfUrl(message.mediaUrl, message.body, message.mediaType)) {
      
      console.log("📄 Renderizando como documento/PDF:", message.id);
      const pdfInfo = extractPdfInfoFromMessage(message);

      return (
        <PdfPreview
          url={pdfInfo.url}
          filename={pdfInfo.filename}
          size={pdfInfo.size}
          mediaType={pdfInfo.mediaType}
          fileStatus={message.fileStatus}
          messageId={message.id}
          onDownload={(url, name) => {
            console.log("📥 Download PDF solicitado:", { url, name });
            downloadPdf(url, name);
          }}
        />
      );
    }

    // Áudio
    else if (isAudioMessage(message)) {
      console.log("🎵 Renderizando como áudio:", message.id);
      return (
        <div style={{
          width: '100%',
          maxWidth: '300px',
          padding: '8px',
          backgroundColor: 'transparent'
        }}>
          <AudioModal
            url={message.mediaUrl}
            message={message}
            ticketUuid={ticketId}
            disableTranscription={!transcriptionEnabled}
          />
        </div>
      );
    }

    // Imagens
    else if (message.mediaType === "image") {
      console.log("🖼️ Renderizando como imagem");
      return <ModalImageCors imageUrl={message.mediaUrl} />;
    }

    // Vídeos
    else if (message.mediaType === "video") {
      const isVideoActive = audioPlayerCtx?.currentAudio?.url === message.mediaUrl
        && audioPlayerCtx?.currentAudio?.mediaType === "video";

      const formatVideoDuration = (sec) => {
        if (!sec || isNaN(sec)) return "";
        const m = Math.floor(sec / 60);
        const s = Math.floor(sec % 60);
        return `${m}:${s.toString().padStart(2, "0")}`;
      };

      const handleVideoPlay = () => {
        if (audioPlayerCtx) {
          const contactName = message?.contact?.name || "";
          audioPlayerCtx.playVideo(message.mediaUrl, message, contactName, ticketId);
        }
      };

      if (videoError) {
        return (
          <div className={classes.videoErrorContainer}>
            <VideocamIcon style={{ fontSize: 36, opacity: 0.4, marginBottom: 8 }} />
            <Typography variant="body2" style={{ marginBottom: 12 }}>
              Erro ao carregar vídeo
            </Typography>
            <Button
              startIcon={<GetApp />}
              onClick={() => {
                const link = document.createElement('a');
                link.href = message.mediaUrl;
                link.download = message.body || 'video.mp4';
                link.click();
              }}
              variant="outlined"
              size="small"
            >
              Baixar Vídeo
            </Button>
          </div>
        );
      }

      // Video is active — show inline player with native controls
      if (isVideoActive) {
        return <InlineVideoPlayer src={message.mediaUrl} />;
      }

      // Thumbnail with play overlay
      return (
        <div
          className={classes.videoContainer}
          onClick={handleVideoPlay}
        >
          <video
            ref={videoThumbRef}
            className={classes.videoThumbnail}
            src={`${message.mediaUrl}#t=0.5`}
            preload="metadata"
            playsInline
            muted
            onLoadStart={() => {
              setVideoLoading(true);
              setVideoError(false);
            }}
            onLoadedMetadata={(e) => {
              setVideoLoading(false);
              if (e.target.duration && isFinite(e.target.duration)) {
                setVideoDuration(e.target.duration);
              }
            }}
            onLoadedData={() => setVideoLoading(false)}
            onError={() => {
              setVideoLoading(false);
              setVideoError(true);
            }}
          />

          {/* Loading overlay */}
          {videoLoading && (
            <div className={classes.videoLoadingOverlay}>
              <CircularProgress size={28} style={{ color: "#fff" }} />
            </div>
          )}

          {/* Play button overlay */}
          {!videoLoading && (
            <div className={classes.videoPlayOverlay}>
              <PlayArrowIcon />
            </div>
          )}

          {/* Duration badge (bottom-left) */}
          {!videoLoading && videoDuration > 0 && (
            <div className={classes.videoDuration}>
              <VideocamIcon />
              <Typography className={classes.videoDurationText}>
                {formatVideoDuration(videoDuration)}
              </Typography>
            </div>
          )}

          {/* Download button (bottom-right) */}
          {!videoLoading && (
            <IconButton
              className={classes.videoDownloadBtn}
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                const link = document.createElement('a');
                link.href = message.mediaUrl;
                link.download = message.body || 'video.mp4';
                link.click();
              }}
              title="Baixar vídeo"
            >
              <GetApp />
            </IconButton>
          )}
        </div>
      );
    }

    // Outros tipos de arquivo (.txt/.docx/.json/.md/.exe/etc) — mostra um card
    // com o nome real do arquivo e a extensão, em vez de só um botão "Download"
    // sem identificação (#4227). Nome do arquivo vem do mediaUrl (o backend já
    // preserva o nome original); a extensão sai do próprio nome.
    else if (message.mediaUrl) {
      const rawName = getBasename(message.mediaUrl);
      // Preferir o caption/nome enviado (body) quando ele parece um nome de
      // arquivo (tem extensão) — senão usar o basename do arquivo salvo.
      const bodyLooksLikeFile = message.body && /\.[a-z0-9]{1,8}$/i.test(message.body.trim());
      const displayName = bodyLooksLikeFile
        ? message.body.trim()
        : (rawName || message.body || i18n.t("messagesList.fileCard.fallbackName"));
      const dot = displayName.lastIndexOf(".");
      const ext = dot > 0 ? displayName.slice(dot + 1).toLowerCase() : "";
      const downloadHint = i18n.t("messagesList.fileCard.download");

      // Contexto do slot: dá ao plugin o que ele precisa pra renderizar/agir
      // sobre o arquivo. Inclui a identidade da CONEXÃO (channel/whatsappId) —
      // sem isso o plugin não sabe se a mensagem é de um canal dele. Um plugin
      // só deve substituir o card das próprias conexões (checa ctx.channel).
      const fileCtx = {
        // arquivo
        filename: displayName,
        ext,
        mimetype: message.mediaType,
        mediaUrl: message.mediaUrl,
        // mensagem
        messageId: message.id,
        wid: message.wid,
        body: message.body,
        fromMe: message.fromMe,
        createdAt: message.createdAt,
        // conexão / ticket (identidade — de quem é esta mensagem)
        ticketId: message.ticketId,
        channel: message.channel || channel,
        whatsappId: message?.ticket?.whatsappId ?? whatsappId,
        isGroup,
      };
      // O card nativo some quando um plugin declara o hook de substituição —
      // idêntico ao padrão do botão de novo ticket (NotificameHub).
      const hideNative = hasFileCardSlot && shouldHide(ticketsUI.hooks.MESSAGE_FILE_CARD_HIDE_NATIVE, fileCtx);

      const nativeCard = hideNative ? null : (
        <div
          className={classes.fileCard}
          onClick={() => downloadPdf(message.mediaUrl, displayName)}
          title={displayName}
        >
          <div className={classes.fileCardIcon}>
            {ext ? ext.slice(0, 4) : <GetApp fontSize="small" />}
          </div>
          <div className={classes.fileCardInfo}>
            <span className={classes.fileCardName}>{displayName}</span>
            <span className={classes.fileCardHint}>
              {ext ? `${ext.toUpperCase()} · ${downloadHint}` : downloadHint}
            </span>
          </div>
        </div>
      );

      return (
        <>
          {hasFileCardSlot ? (
            <PluginBridge slot={ticketsUI.slots.MESSAGE_FILE_CARD} as="text-buttons" context={fileCtx}>
              {nativeCard}
            </PluginBridge>
          ) : (
            nativeCard
          )}
          <Divider />
        </>
      );
    }

    return null;
  };


  const renderMessageContentSlot = (message) =>
    hasMsgContentSlot ? (
      <PluginBridge
        slot={ticketsUI.slots.MESSAGE_CONTENT}
        as="text-buttons"
        context={messageSlotContext(message)}
        // O plugin pode oferecer texto ao rascunho (`slot.insertText`) — é como
        // um botão desenhado na bolha chega à caixa de digitação, que é
        // componente irmão deste.
        onInsertText={inserirNoRascunho}
      />
    ) : null;

  // Canal cujo corpo precisa de outra renderização (emoji do Discord como
  // imagem, por exemplo) declara o hook e desenha o texto no próprio slot.
  const ocultarCorpoNativo = (message) =>
    hasMsgContentSlot &&
    shouldHide(ticketsUI.hooks.MESSAGE_CONTENT_HIDE_NATIVE, messageSlotContext(message));

  const renderMessageFooterSlot = (message) =>
    hasMsgFooterSlot ? (
      <PluginBridge
        slot={ticketsUI.slots.MESSAGE_FOOTER}
        as="text-buttons"
        context={messageSlotContext(message)}
      />
    ) : null;

  const renderReactions = (message) => {
    if (!message.reactions || typeof message.reactions !== "object") return null;

    const entries = Object.entries(message.reactions);
    if (entries.length === 0) return null;

    // Canal cujo emoji é IMAGEM (Discord) desenha a própria faixa: o nativo só
    // sabe mostrar caractere, e ali o emoji chega como ":nome:".
    if (hasReactionsSlot) {
      const ctx = { ...messageSlotContext(message), reactions: message.reactions };
      const slotDeReacoes = (
        <PluginBridge
          slot={ticketsUI.slots.MESSAGE_REACTIONS}
          as="text-buttons"
          context={ctx}
        />
      );
      if (shouldHide(ticketsUI.hooks.MESSAGE_REACTIONS_HIDE_NATIVE, ctx)) return slotDeReacoes;
    }

    return (
      <div className={classes.reactionsContainer}>
        {entries.map(([emoji, senders]) => (
          <span
            key={emoji}
            className={classes.reactionBadge}
            title={Array.isArray(senders) ? senders.join(", ") : ""}
          >
            <span className={classes.reactionEmoji}>{emoji}</span>
            {Array.isArray(senders) && senders.length > 1 && (
              <span className={classes.reactionCount}>{senders.length}</span>
            )}
          </span>
        ))}
        {hasReactionsSlot && (
          <PluginBridge
            slot={ticketsUI.slots.MESSAGE_REACTIONS}
            as="text-buttons"
            context={{ ...messageSlotContext(message), reactions: message.reactions }}
          />
        )}
      </div>
    );
  };

  // #4106: reenvia uma mensagem que falhou (ack === -1).
  // #4195: o reenvio deixou de ser só de mídia, então o texto não fala mais em
  // "arquivo" — e saiu do hardcode em português para o i18n.
  const handleResend = async (message) => {
    const toastId = toast.info(i18n.t("messagesList.resending"), { autoClose: false });
    try {
      await api.post(`/messages/${message.id}/resend`);
      toast.update(toastId, {
        render: i18n.t("messagesList.resent"),
        type: "success",
        autoClose: 3000,
      });
    } catch (err) {
      toast.dismiss(toastId);
      toastError(err);
    }
  };

  // #4192 item 2: mesmo limiar do FailStuckMessagesJob (backend) — antes do
  // job rodar (cron de 1min + espera de 90s = até ~150s), o front já detecta
  // e libera o reenvio, sem esperar o ciclo do servidor.
  const ACK_STUCK_TIMEOUT_MS = 90 * 1000;
  const isAckStuck = (message) =>
    message.ack === 0 &&
    message.fromMe &&
    !message.isPrivate &&
    Date.now() - new Date(message.createdAt).getTime() > ACK_STUCK_TIMEOUT_MS;

  // #4195: mensagem que falhou no envio (ack=-1) ou ficou presa em ack=0.
  const hasFailedToSend = (message) =>
    message.ack === -1 || isAckStuck(message);

  /**
   * Faixa "Reenviar" acoplada à ESQUERDA do balão.
   *
   * #4195: antes era só um ícone dentro do rodapé do balão, disputando o canto
   * com horário, tiques e a seta do menu de ações. Em mensagem curta ("1") não
   * havia espaço e o clique caía no menu. Ajustes de zIndex/padding não
   * resolvem um problema de espaço — o botão saiu do balão.
   *
   * Texto visível (não só ícone) para o atendente entender que precisa clicar.
   */
  const renderResendButton = (message) => {
    if (!hasFailedToSend(message)) return null;

    return (
      <Button
        size="small"
        variant="contained"
        disableElevation
        className={classes.resendButton}
        startIcon={<ErrorOutlineIcon style={{ fontSize: 16 }} />}
        title={i18n.t("messagesList.resendFailed")}
        onClick={(e) => {
          // Impede que o clique borbulhe e abra o menu de contexto.
          e.stopPropagation();
          handleResend(message);
        }}
      >
        {i18n.t("messagesList.resendButton")}
      </Button>
    );
  };

  const renderMessageAck = (message) => {
    // #4106: mídia que não foi entregue (presa em ack=0 ou erro no envio).
    // #4195: o clique para reenviar mudou para o botão ao lado do balão; aqui
    // fica só o indicador visual de falha.
    if (hasFailedToSend(message)) {
      return (
        <ErrorOutlineIcon
          fontSize="small"
          style={{ color: "#e53935", fontSize: 16 }}
          titleAccess={i18n.t("messagesList.resendFailed")}
        />
      );
    } else if (message.ack === 0) {
      return <AccessTime fontSize="small" className={classes.ackIcons} />;
    } else
      if (message.ack === 1) {
        return <Done fontSize="small" className={classes.ackIcons} />;
      } else
        if (message.ack === 2 || message.ack === 3) {
          return <DoneAll fontSize="small" className={classes.ackIcons} />;
        } else
          if (message.ack === 4) {
            return <DoneAll fontSize="small" className={message.mediaType === "audio" ? classes.ackPlayedIcon : classes.ackDoneAllIcon} />;
          } else
            if (message.ack === 5) {
              return <DoneAll fontSize="small" className={classes.ackDoneAllIcon} />
            }
  };

  const renderDailyTimestamps = (message, index) => {
    const today = format(new Date(), "dd/MM/yyyy")

    if (index === 0) {
      return (
        <span
          className={classes.dailyTimestamp}
          key={`timestamp-${message.id}`}
        >
          <div className={classes.dailyTimestampText}>
            {today === format(parseISO(messagesList[index].createdAt), "dd/MM/yyyy") ? "HOJE" : format(parseISO(messagesList[index].createdAt), "dd/MM/yyyy")}
          </div>
        </span>
      );
    } else
      if (index < messagesList.length - 1) {
        let messageDay = parseISO(messagesList[index].createdAt);
        let previousMessageDay = parseISO(messagesList[index - 1].createdAt);

        if (!isSameDay(messageDay, previousMessageDay)) {
          return (
            <span
              className={classes.dailyTimestamp}
              key={`timestamp-${message.id}`}
            >
              <div className={classes.dailyTimestampText}>
                {today === format(parseISO(messagesList[index].createdAt), "dd/MM/yyyy") ? "HOJE" : format(parseISO(messagesList[index].createdAt), "dd/MM/yyyy")}
              </div>
            </span>
          );
        }
      } else
        if (index === messagesList.length - 1) {
          return (
            <div
              key={`ref-${message.id}`}
              ref={lastMessageRef}
              style={{ float: "left", clear: "both" }}
            />
          );
        }
  };

  const renderTicketsSeparator = (message, index) => {
    const lastTicket = messagesList[index - 1]?.ticketId;
    const currentTicket = message.ticketId;

    // #4155: ver mergedHistory.js — com o merge a PRIMEIRA seção também ganha
    // faixa, senão fica anônima (o fio começa em um ticket qualquer do contato).
    if (
      !shouldRenderSeparator({
        previousTicketId: lastTicket,
        currentTicketId: currentTicket,
        mergeHistoryByContact
      })
    ) {
      return null;
    }

    // #4155: a faixa não pode depender SÓ desta mensagem — o update de ACK
    // pode tê-la deixado com o ticket parcial (sem queue/whatsapp) e a faixa
    // regredia para "Sem Fila". O índice (memoizado, uma passada por render da
    // lista) guarda o dado de qualquer mensagem do mesmo ticket.
    // #4241: para a seção do ticket ABERTO a fila vem do ticket ao vivo (socket),
    // não da mensagem — senão transferir/aceitar não muda a faixa até o F5.
    const queue = resolveSeparatorQueue({
      sectionTicketId: currentTicket,
      openTicketId,
      openTicketQueue,
      openTicketQueueId,
      messageQueue: message?.ticket?.queue,
      indexQueue: ticketDataIndex.get(currentTicket)?.queue
    });
    // identifica de QUAL conexão veio este trecho do histórico — sem isso, com
    // o histórico mesclado o usuário não distingue o que foi atendido por cada
    // número.
    const whatsapp =
      message?.ticket?.whatsapp ?? ticketDataIndex.get(currentTicket)?.whatsapp;
    const previousMessage = messagesList[index - 1];
    const previousWhatsapp =
      previousMessage?.ticket?.whatsapp ?? ticketDataIndex.get(lastTicket)?.whatsapp;

    const nativeSeparator = shouldHide(
      ticketsUI.hooks.MESSAGE_TICKET_SEPARATOR_HIDE_NATIVE
    ) ? null : (
      <div
        className={classes.currentTicktText}
        style={{ backgroundColor: queue?.color || "grey" }}
      >
        #{i18n.t("ticketsList.called")} {currentTicket} -{" "}
        {queue?.name || i18n.t("ticketsList.noQueue")}
        {whatsapp?.name && ` · ${whatsapp.name}`}
        {whatsapp?.number && ` (${whatsapp.number})`}
      </div>
    );

    if (!hasTicketSeparatorSlot) {
      return (
        <span className={classes.currentTick} key={`timestamp-${message.id}a`}>
          {nativeSeparator}
        </span>
      );
    }

    const separatorCtx = {
      ticketId: currentTicket,
      previousTicketId: lastTicket,
      queue: queue
        ? { id: queue.id, name: queue.name, color: queue.color }
        : undefined,
      connection: whatsapp
        ? { id: whatsapp.id, name: whatsapp.name, number: whatsapp.number }
        : undefined,
      previousConnection: previousWhatsapp
        ? {
            id: previousWhatsapp.id,
            name: previousWhatsapp.name,
            number: previousWhatsapp.number
          }
        : undefined,
      // Deixa explícito o caso que interessa ao plugin: a faixa marca troca de
      // CONEXÃO, não só de ticket.
      isConnectionChange:
        !!previousWhatsapp?.id && previousWhatsapp.id !== whatsapp?.id,
      channel: message?.ticket?.channel,
      isGroup: message?.ticket?.isGroup
    };

    return (
      <span className={classes.currentTick} key={`timestamp-${message.id}a`}>
        <PluginBridge
          slot={ticketsUI.slots.MESSAGE_TICKET_SEPARATOR}
          as="text-buttons"
          context={separatorCtx}
        >
          {nativeSeparator}
        </PluginBridge>
      </span>
    );
  };

  const renderMessageDivider = (message, index) => {
    if (index < messagesList.length && index > 0) {
      let messageUser = messagesList[index].fromMe;
      let previousMessageUser = messagesList[index - 1].fromMe;
      if (messageUser !== previousMessageUser) {
        return (

          <span style={{ marginTop: 16 }} key={`divider-${message.id}`}></span>
        );
      }
    }
  };

  const renderQuotedMessage = (message) => {

    return (
      <div
        className={clsx(classes.quotedContainerLeft, {
          [classes.quotedContainerRight]: message.fromMe,
        })}
      >
        <span
          className={clsx(classes.quotedSideColorLeft, {
            [classes.quotedSideColorRight]: message.quotedMsg?.fromMe,
          })}
        ></span>
        <div className={classes.quotedMsg}>
          {!message.quotedMsg?.fromMe && (
            <span className={classes.messageContactName}>
              {message.quotedMsg?.contact?.name}
            </span>
          )}

          {message.quotedMsg.mediaType === "audio"
            && (
              <div className={classes.downloadMedia}>
                <AudioModal url={message.quotedMsg.mediaUrl} />
              </div>
            )
          }
          {message.quotedMsg.mediaType === "video"
            && (
              <div
                className={classes.videoContainer}
                style={{ maxWidth: 220, cursor: "pointer" }}
                onClick={() => {
                  if (audioPlayerCtx) {
                    const contactName = message?.contact?.name || "";
                    audioPlayerCtx.playVideo(message.quotedMsg.mediaUrl, message.quotedMsg, contactName, ticketId);
                  }
                }}
              >
                <video
                  className={classes.videoThumbnail}
                  src={`${message.quotedMsg.mediaUrl}#t=0.5`}
                  preload="metadata"
                  playsInline
                  muted
                  style={{ maxHeight: 150 }}
                />
                <div className={classes.videoPlayOverlay} style={{ width: 36, height: 36 }}>
                  <PlayArrowIcon style={{ fontSize: 20 }} />
                </div>
              </div>
            )
          }
          {message.quotedMsg.mediaType === "contactMessage"
            && (
              "Contato"
            )
          }
          {message.quotedMsg.mediaType === "application"
            && (
              <div className={classes.downloadMedia}>
                <Button
                  startIcon={<GetApp />}
                  variant="outlined"
                  target="_blank"
                  href={message.quotedMsg.mediaUrl}
                >
                  Download
                </Button>
              </div>
            )
          }

          {message.quotedMsg.mediaType === "image"
            && (
              <ModalImageCors imageUrl={message.quotedMsg.mediaUrl} />)
            || message.quotedMsg?.body}

          {!message.quotedMsg.mediaType === "image" && message.quotedMsg?.body}

        </div>
      </div>
    );
  };

  const handleDrag = event => {
    event.preventDefault();
    event.stopPropagation();

    if (dropProcessing) return;

    if (event.type === "dragenter" || event.type === "dragover") {
      const hasFiles = event.dataTransfer &&
        event.dataTransfer.types &&
        (event.dataTransfer.types.includes('Files') ||
          event.dataTransfer.types.includes('application/x-moz-file'));

      if (hasFiles) {
        setDragActive(true);
      }
    } else if (event.type === "dragleave") {
      const rect = event.currentTarget.getBoundingClientRect();
      const x = event.clientX;
      const y = event.clientY;

      if (x < rect.left || x > rect.right || y < rect.top || y > rect.bottom) {
        setDragActive(false);
      }
    }
  }

  const isYouTubeLink = (url) => {
    const youtubeRegex = /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    return youtubeRegex.test(url);
  };

  const handleDrop = event => {
    event.preventDefault();
    event.stopPropagation();

    if (dropProcessing) return;

    setDragActive(false);

    if (event.dataTransfer.files &&
      event.dataTransfer.files.length > 0 &&
      event.dataTransfer.files[0] instanceof File) {
      if (onDrop) {
        setDropProcessing(true);
        onDrop(event.dataTransfer.files);
        setTimeout(() => setDropProcessing(false), 3000);
      }
    }
  }
  const xmlRegex = /<([^>]+)>/g;
  const boldRegex = /\*(.*?)\*/g;

  const formatXml = (xmlString) => {
    // Verifica se o XML contém a assinatura com nome do atendente
    if (boldRegex.test(xmlString)) {
      // Formata o texto dentro da assinatura em negrito
      xmlString = xmlString.replace(boldRegex, "**$1**");
    }
    return xmlString;
  };

  // #4292 — faixa da observacao do contato. Nao e mensagem: nao vem de
  // Messages, nao e enviada e nao entra no historico nem no PDF.
  const renderContactNotesBanner = () => (
    <div className={classes.contactNotesBanner} key="contact-notes-banner">
      <div
        className={classes.contactNotesHeader}
        onClick={() => setNotesCollapsed(prev => !prev)}
        title={notesCollapsed ? "Mostrar observações" : "Minimizar"}
      >
        <AssignmentIcon fontSize="small" />
        <span style={{ flexGrow: 1 }}>Observações do contato</span>
        {notesCollapsed ? (
          <ExpandMoreIcon fontSize="small" />
        ) : (
          <ExpandLessIcon fontSize="small" />
        )}
      </div>
      {!notesCollapsed && (
        <div className={classes.contactNotesBody}>{contactNotes}</div>
      )}
    </div>
  );

  const renderMessages = () => {

    if (messagesList.length > 0) {
      const viewMessagesList = messagesList.map((message, index) => {
        if (message.mediaType === "call_log") {
          return (
            <React.Fragment key={message.id}>
              {renderDailyTimestamps(message, index)}
              {renderTicketsSeparator(message, index)}
              {renderMessageDivider(message, index)}
              <div
                className={classes.messageCenter}
                onContextMenu={(e) => handleContextMenu(e, message)}
              >
                <IconButton
                  variant="contained"
                  size="small"
                  id="messageActionsButton"
                  disabled={message.isDeleted}
                  className={classes.messageActionsButton}
                  onClick={(e) => handleOpenMessageOptionsMenu(e, message)}
                >
                  <ExpandMore />
                </IconButton>
                {isGroup && (
                  <span className={classes.messageContactName}>
                    {message.contact?.name}
                  </span>
                )}

                <div>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 17" width="20" height="17">
                    <path fill="#df3333" d="M18.2 12.1c-1.5-1.8-5-2.7-8.2-2.7s-6.7 1-8.2 2.7c-.7.8-.3 2.3.2 2.8.2.2.3.3.5.3 1.4 0 3.6-.7 3.6-.7.5-.2.8-.5.8-1v-1.3c.7-1.2 5.4-1.2 6.4-.1l.1.1v1.3c0 .2.1.4.2.6.1.2.3.3.5.4 0 0 2.2.7 3.6.7.2 0 1.4-2 .5-3.1zM5.4 3.2l4.7 4.6 5.8-5.7-.9-.8L10.1 6 6.4 2.3h2.5V1H4.1v4.8h1.3V3.2z"></path>
                  </svg> <span>{i18n.t("ticketsList.missedCall")} {format(parseISO(message.createdAt), "HH:mm")}</span>
                </div>
              </div>
            </React.Fragment>
          );
        }

        if (!message.fromMe) {
          return (
            <React.Fragment key={message.id}>
              {renderDailyTimestamps(message, index)}
              {renderTicketsSeparator(message, index)}
              {renderMessageDivider(message, index)}
              <div
                className={classes.messageLeft}
                title={message.queueId && message.queue?.name}
                onDoubleClick={(e) => hanldeReplyMessage(e, message)}
                onContextMenu={(e) => handleContextMenu(e, message)}
              >
                {showSelectMessageCheckbox && (
                  <SelectMessageCheckbox
                    message={message}
                  />
                )}
                <IconButton
                  variant="contained"
                  size="small"
                  id="messageActionsButton"
                  disabled={message.isDeleted}
                  className={classes.messageActionsButton}
                  onClick={(e) => handleOpenMessageOptionsMenu(e, message)}
                >
                  <ExpandMore />
                </IconButton>

                {message.isForwarded && (
                  <div>
                    <span className={classes.forwardMessage}
                    ><Reply style={{ color: "grey", transform: 'scaleX(-1)' }} /> Encaminhada
                    </span>
                    <br />
                  </div>
                )}
                {isGroup && (
                  <span className={classes.messageContactName}>
                    {message.contact?.name}
                  </span>
                )}
                {isYouTubeLink(message.body) && (
                  <>
                    <YouTubePreview videoUrl={message.body} />
                  </>
                )}

                {!lgpdDeleteMessage && message.isDeleted && (
                  <div>
                    <span className={classes.deletedMessage}
                    >🚫 Essa mensagem foi apagada pelo contato &nbsp;
                    </span>
                  </div>
                )}

                {/* #4106: se o envio falhou (ack=-1) ou está preso há muito tempo em
                    ack=0 (ver isAckStuck, #4192 item 2), NÃO mostramos a mídia normal
                    (com download/preview) — ela nunca chegou ao contato. Mostramos
                    uma bolha de falha com o nome do arquivo e a opção de reenviar. */}
                {message.fromMe && (message.ack === -1 || isAckStuck(message)) ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 6,
                      padding: "8px 10px",
                      borderRadius: 8,
                      background: "rgba(229, 57, 53, 0.10)",
                      border: "1px solid rgba(229, 57, 53, 0.4)",
                      color: "#e53935",
                      fontSize: 13,
                      maxWidth: 260,
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                      <ErrorOutlineIcon style={{ fontSize: 18 }} />
                      <strong>{i18n.t("messagesList.sendFailed")}</strong>
                    </div>
                    <span style={{ fontSize: 12, color: "#b71c1c", wordBreak: "break-all" }}>
                      {message.mediaUrl || message.body}
                    </span>
                    <span
                      onClick={() => handleResend(message)}
                      style={{
                        cursor: "pointer",
                        fontWeight: 600,
                        textDecoration: "underline",
                        alignSelf: "flex-start",
                      }}
                    >
                      {i18n.t("messagesList.resendButton")}
                    </span>
                  </div>
                ) : (
                  (message.mediaUrl || message.mediaType === "locationMessage" || message.mediaType === "contactMessage" || message.mediaType === "template" || message.mediaType === "adMetaPreview"
                  ) && checkMessageMedia(message)
                )}

                <div className={clsx(
                  (message.mediaUrl && (message.mediaType === "image" || message.mediaType === "video"))
                    ? classes.textContentItemMedia
                    : classes.textContentItem,
                  {
                    [classes.textContentItemDeleted]: message.isDeleted,
                  }
                )}>
                  {message.quotedMsg && renderQuotedMessage(message)}
                  {
                    !ocultarCorpoNativo(message) &&
                    message.mediaType !== "adMetaPreview" && (
                      (message.mediaUrl !== null && (message.mediaType === "image" || message.mediaType === "video") && getBasename(message.mediaUrl).trim() !== message.body.trim()) ||
                      message.mediaType !== "audio" &&
                      message.mediaType !== "image" &&
                      message.mediaType !== "video" &&
                      message.mediaType != "reactionMessage" &&
                      message.mediaType != "locationMessage" &&
                      message.mediaType !== "contactMessage" &&
                      message.mediaType !== "template"
                    ) && (
                      <>
                        {xmlRegex.test(message.body) && (
                          <span>{message.body}</span>

                        )}
                        {!xmlRegex.test(message.body) && (
                          message.isPendingFragment ? (
                            <span className={classes.pendingFragmentMessage}>
                              <AccessTime className={classes.pendingFragmentIcon} />
                              {message.body}
                            </span>
                          ) : (
                            <MarkdownWrapper>
                              {(lgpdDeleteMessage && message.isDeleted) ? "🚫 _Mensagem apagada_ " : message.body}
                            </MarkdownWrapper>
                          )
                        )}

                      </>

                    )}

                  {message.quotedMsg && message.mediaType === "reactionMessage" && (
                    <>
                      <span style={{ marginLeft: "0px" }}>
                        <MarkdownWrapper>
                          {"" + message?.contact?.name + " reagiu... " + message.body}
                        </MarkdownWrapper>
                      </span>
                    </>
                  )}

                  {renderMessageContentSlot(message)}

                  <span className={classes.timestamp}>
                    {message.isEdited ? "Editada " + format(parseISO(message.createdAt), "HH:mm") : format(parseISO(message.createdAt), "HH:mm")}
                    {renderMessageFooterSlot(message)}
                  </span>
                </div>
                {renderReactions(message)}
              </div>
            </React.Fragment>
          );
        } else {
          return (
            <React.Fragment key={message.id}>
              {renderDailyTimestamps(message, index)}
              {renderTicketsSeparator(message, index)}
              {renderMessageDivider(message, index)}
              <div className={classes.messageRowRight}>
              {renderResendButton(message)}
              <div
                className={clsx(
                  message.isPrivate ? classes.messageRightPrivate : classes.messageRight,
                  // #4195: com a faixa acoplada, o canto esquerdo do balão fica
                  // reto para os dois encostarem sem fresta.
                  { [classes.messageRightCoupled]: hasFailedToSend(message) }
                )}
                title={message.queueId && message.queue?.name}
                onDoubleClick={(e) => hanldeReplyMessage(e, message)}
                onContextMenu={(e) => handleContextMenu(e, message)}
              >
                {showSelectMessageCheckbox && (
                  <SelectMessageCheckbox
                    message={message}
                  />
                )}

                <IconButton
                  variant="contained"
                  size="small"
                  id="messageActionsButton"
                  disabled={message.isDeleted}
                  className={classes.messageActionsButton}
                  onClick={(e) => handleOpenMessageOptionsMenu(e, message)}
                >
                  <ExpandMore />
                </IconButton>
                {message.isForwarded && (
                  <div>
                    <span className={classes.forwardMessage}
                    ><Reply style={{ color: "grey", transform: 'scaleX(-1)' }} /> Encaminhada
                    </span>
                    <br />
                  </div>
                )}
                {isYouTubeLink(message.body) && (
                  <>
                    <YouTubePreview videoUrl={message.body} />
                  </>
                )}
                {!lgpdDeleteMessage && message.isDeleted && (
                  <div>
                    <span className={classes.deletedMessage}
                    >🚫 Essa mensagem foi apagada &nbsp;
                    </span>
                  </div>
                )}
                {(message.mediaUrl || message.mediaType === "locationMessage" || message.mediaType === "contactMessage" || message.mediaType === "template"
                ) && checkMessageMedia(message)}
                <div
                  className={clsx(
                    (message.mediaUrl && (message.mediaType === "image" || message.mediaType === "video"))
                      ? classes.textContentItemMedia
                      : classes.textContentItem,
                    {
                      [classes.textContentItemDeleted]: message.isDeleted,
                    }
                  )}
                >

                  {message.quotedMsg && renderQuotedMessage(message)}

                  {
                    !ocultarCorpoNativo(message) &&
                    (((message.mediaType === "image" || message.mediaType === "video") && getBasename(message.mediaUrl) === message.body) ||
                    (message.mediaType !== "audio" && message.mediaType != "reactionMessage" && message.mediaType != "locationMessage" && message.mediaType !== "contactMessage" && message.mediaType !== "template") && (
                      <>
                        {xmlRegex.test(message.body) && (
                          <div>{formatXml(message.body)}</div>

                        )}
                        {!xmlRegex.test(message.body) && (
                          message.isPendingFragment ? (
                            <span className={classes.pendingFragmentMessage}>
                              <AccessTime className={classes.pendingFragmentIcon} />
                              {message.body}
                            </span>
                          ) : (
                            <MarkdownWrapper>
                              {message.body}
                            </MarkdownWrapper>
                          )
                        )}

                      </>
                    ))}

                  {message.quotedMsg && message.mediaType === "reactionMessage" && (
                    <>
                      <span style={{ marginLeft: "0px" }}>
                        <MarkdownWrapper>
                          {"Você reagiu... " + message.body}
                        </MarkdownWrapper>
                      </span>
                    </>
                  )}

                  {renderMessageContentSlot(message)}

                  <span className={classes.timestamp}>
                    {message.isEdited ? "Editada " + format(parseISO(message.createdAt), "HH:mm") : format(parseISO(message.createdAt), "HH:mm")}
                    {renderMessageFooterSlot(message)}
                    {renderMessageAck(message)}
                  </span>
                </div>
                {renderReactions(message)}
              </div>
              </div>
            </React.Fragment>
          );
        }
      });
      // Fixa a ancora na primeira vez que ha mensagens (carregamento inicial).
      if (notesAfterMessageId.current == null && messagesList.length) {
        notesAfterMessageId.current = messagesList[messagesList.length - 1]?.id ?? null;
      }

      if (contactNotes && notesAfterMessageId.current != null) {
        // map() devolve um item por mensagem, entao o indice bate com a lista.
        const pos = messagesList.findIndex(m => m.id === notesAfterMessageId.current);
        if (pos >= 0) viewMessagesList.splice(pos + 1, 0, renderContactNotesBanner());
      }

      return viewMessagesList;
    } else {
      return <div>Diga olá para seu novo contato!</div>;
    }
  };
const shouldBlurMessages = ticketStatus === "pending" && user.allowSeeMessagesInPendingTickets === "disabled";

  return (
    <div className={classes.messagesListWrapper} onDragEnter={handleDrag}>
      {dragActive && <div className={classes.dragElement} onDragEnter={handleDrag} onDragLeave={handleDrag} onDragOver={handleDrag} onDrop={handleDrop}>Solte o arquivo aqui</div>}
      {dropProcessing && (
        <div className={classes.dropProcessingOverlay}>
          <CircularProgress size={48} />
          <Typography variant="h6">Preparando arquivo...</Typography>
        </div>
      )}
      <MessageOptionsMenu
        message={selectedMessage}
        anchorEl={anchorEl}
        menuOpen={messageOptionsMenuOpen}
        handleClose={handleCloseMessageOptionsMenu}
        isGroup={isGroup}
        whatsappId={whatsappId}
        queueId={queueId}
      />
      

<div
  id="messagesList"
  className={classes.messagesList}
  onScroll={handleScroll}
  style={{
    filter: shouldBlurMessages ? "blur(4px)" : "none",
    pointerEvents: shouldBlurMessages ? "none" : "auto"
  }}
>
  {/* #4080: mostrar sempre que houver histórico. Antes exigia `!hasMore`, ou
      seja, só aparecia depois de esgotar as páginas ROLANDO — e sem barra de
      rolagem (zoom alto, poucas mensagens) isso nunca acontecia, deixando o
      usuário sem forma nenhuma de buscar mensagens antigas. */}
  {hasMoreHistory && (
    <div style={{ display: "flex", justifyContent: "center", padding: "8px 0" }}>
      <Button
        variant="outlined"
        size="small"
        onClick={loadOlderHistory}
        disabled={loadingHistory}
        startIcon={loadingHistory ? <CircularProgress size={16} /> : <HistoryIcon />}
      >
        {loadingHistory ? i18n.t("messagesList.header.loadingHistory") : i18n.t("messagesList.header.loadHistory")}
      </Button>
    </div>
  )}
  {messagesList.length > 0 ? renderMessages() : []}

</div>

      {loading && (
        <div>
          <CircularProgress className={classes.circleLoading} />
        </div>
      )}
    </div>
  );
};

export default MessagesList;